import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { AnimatedSection } from "../shared";
import agntLogoSrc from "assets/landing/agnt-logo-nobg.png";

export function AgntProducts() {
  return (
    <section className="py-12 md:py-16 px-6 relative overflow-hidden bg-[#f5f5f5]">
      <div className="max-w-7xl mx-auto w-full relative z-10">
        <AnimatedSection>
          <div className="mb-12">
            <span className="inline-flex items-center gap-2.5 text-[11px] font-semibold tracking-[0.2em] uppercase text-black/40 mb-5 before:content-[''] before:w-5 before:h-px before:bg-gradient-to-r before:from-black/30 before:to-transparent">
              One hub. Three access points.
            </span>
            <h2 className="font-space-grotesk text-4xl md:text-6xl font-bold tracking-[-0.03em] text-black">
              AGNT.Hub Products
            </h2>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {/* AGNT Connect Card */}
          <AnimatedSection delay={0.1}>
            <div className="h-full bg-white border border-black/[0.08] rounded-2xl overflow-hidden group hover:border-black/[0.15] transition-all duration-500 hover:shadow-lg flex flex-col">
              <div className="relative h-[260px] bg-gradient-to-b from-[#1a1a1f] to-[#111115] overflow-hidden">
                {/* Browser mockup */}
                <div className="absolute top-2 left-[4%] w-[62%] h-[245px] rounded-lg bg-white overflow-hidden shadow-xl border border-black/[0.06]">
                  <div className="h-4 bg-white flex items-center px-1.5 gap-1 border-b border-black/[0.06]">
                    <div className="flex gap-[3px]">
                      <div className="w-[5px] h-[5px] rounded-full bg-[#ff5f57]" />
                      <div className="w-[5px] h-[5px] rounded-full bg-[#febc2e]" />
                      <div className="w-[5px] h-[5px] rounded-full bg-[#28c840]" />
                    </div>
                    <div className="flex-1 flex justify-center">
                      <div className="w-20 h-2.5 rounded-full bg-black/[0.04] flex items-center justify-center">
                        <span className="text-[4px] text-black/30">x.com</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex h-[calc(100%-16px)]">
                    <div className="w-8 border-r border-black/[0.06] py-2 flex flex-col items-center gap-2">
                      <span className="text-[7px] font-black text-black/80">
                        {"\u{1D54F}"}
                      </span>
                      {[
                        "\uD83C\uDFE0",
                        "\uD83D\uDD0D",
                        "\uD83D\uDD14",
                        "\u2709\uFE0F",
                        "\uD83D\uDC64",
                      ].map((icon, ii) => (
                        <span
                          key={ii}
                          className={`text-[5px] ${ii === 0 ? "opacity-80" : "opacity-30"}`}
                        >
                          {icon}
                        </span>
                      ))}
                      <div className="mt-auto w-5 h-5 rounded-full bg-[#1d9bf0] flex items-center justify-center">
                        <span className="text-[6px] text-white font-bold">
                          +
                        </span>
                      </div>
                    </div>

                    <div className="flex-1 flex flex-col">
                      <div className="px-2 py-1 border-b border-black/[0.06] flex items-center justify-between">
                        <span className="text-[5px] font-bold text-black/80">
                          Home
                        </span>
                        <div className="flex gap-2">
                          <span className="text-[4px] font-semibold text-black/70 border-b border-[#1d9bf0] pb-0.5">
                            For you
                          </span>
                          <span className="text-[4px] text-black/30">
                            Following
                          </span>
                        </div>
                      </div>

                      <div className="flex-1 overflow-hidden">
                        {TWEETS.map((tweet) => (
                          <div
                            key={tweet.handle}
                            className="px-2 py-1.5 border-b border-black/[0.06]"
                          >
                            <div className="flex gap-1">
                              <div className="w-3 h-3 rounded-full bg-gradient-to-br from-black/10 to-black/5 shrink-0" />
                              <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-0.5">
                                  <span className="text-[4px] font-bold text-black/80">
                                    {tweet.user}
                                  </span>
                                  <span className="text-[3px] text-black/30">
                                    {tweet.handle} &middot; {tweet.time}
                                  </span>
                                </div>
                                <p className="text-[3.5px] text-black/60 leading-[1.5] mt-px whitespace-pre-line">
                                  {tweet.text}
                                </p>
                                {tweet.hashtags && (
                                  <p className="text-[3px] text-[#1d9bf0] mt-px">
                                    {tweet.hashtags}
                                  </p>
                                )}
                                <div className="flex items-center gap-3 mt-1">
                                  <span className="text-[3px] text-black/25">
                                    {"\uD83D\uDCAC"} 48
                                  </span>
                                  <span className="text-[3px] text-black/25">
                                    {"\uD83D\uDD04"} {tweet.rts}
                                  </span>
                                  <span className="text-[3px] text-black/25">
                                    {"\u2764\uFE0F"} {tweet.likes}
                                  </span>
                                  <span className="text-[3px] text-black/25">
                                    {"\uD83D\uDCE4"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Extension panel mockup */}
                <div className="absolute top-2 right-[4%] w-[28%] h-[245px] rounded-lg bg-[#1c1c1e] overflow-hidden shadow-2xl border border-white/[0.08]">
                  <div className="h-3.5 bg-[#2c2c2e] flex items-center px-1.5 gap-1">
                    <div className="w-1 h-1 rounded-full bg-[#30d158]" />
                    <span className="text-[4px] text-white/40 font-medium">
                      AGNT Connect
                    </span>
                    <div className="ml-auto flex items-center gap-0.5">
                      <div className="w-8 h-2 rounded bg-[#3a3a3c] flex items-center justify-center">
                        <span className="text-[3px] text-white/30">
                          {"\uD83D\uDD0D"} Search
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="p-1.5 flex flex-col gap-1.5 overflow-hidden h-[calc(100%-14px)]">
                    <div className="text-center">
                      <span className="text-[4px] text-white/25 block">
                        Portfolio
                      </span>
                      <span className="text-[10px] font-semibold text-white/90 tracking-tight block">
                        $12,352.02
                      </span>
                    </div>

                    <div className="bg-[#2c2c2e] rounded-lg p-1.5">
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-[4px]">{"\uD83D\uDE28"}</span>
                        <span className="text-[4px] text-white/40 font-medium">
                          Fear & Greed Index
                        </span>
                      </div>
                      <div className="flex items-center justify-center">
                        <div className="relative w-[50px] h-[26px]">
                          <svg viewBox="0 0 50 26" className="w-full h-full">
                            <path
                              d="M5 25 A20 20 0 0 1 45 25"
                              fill="none"
                              stroke="url(#fgGrad)"
                              strokeWidth="4"
                              strokeLinecap="round"
                            />
                            <defs>
                              <linearGradient
                                id="fgGrad"
                                x1="0"
                                y1="0"
                                x2="1"
                                y2="0"
                              >
                                <stop offset="0%" stopColor="#ff453a" />
                                <stop offset="25%" stopColor="#ff9f0a" />
                                <stop offset="50%" stopColor="#ffd60a" />
                                <stop offset="75%" stopColor="#30d158" />
                                <stop offset="100%" stopColor="#30d158" />
                              </linearGradient>
                            </defs>
                            <line
                              x1="25"
                              y1="25"
                              x2="18"
                              y2="10"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              opacity="0.7"
                            />
                          </svg>
                          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1">
                            <span className="text-[8px] font-bold text-white/80">
                              29
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="text-center mt-0.5">
                        <span className="text-[4px] text-[#ff9f0a] font-medium">
                          Fear
                        </span>
                      </div>
                    </div>

                    <div>
                      <span className="text-[4px] text-white/30 font-medium block mb-0.5">
                        Top Assets
                      </span>
                      {TOP_ASSETS.map((a) => (
                        <div
                          key={a.name}
                          className="flex items-center gap-1 py-[2px]"
                        >
                          <span className={`text-[6px] ${a.color}`}>
                            {a.icon}
                          </span>
                          <span className="text-[4px] text-white/60 font-medium flex-1">
                            {a.name}
                          </span>
                          <span className="text-[4px] text-white/70 font-medium">
                            {a.price}
                          </span>
                        </div>
                      ))}
                    </div>

                    <div>
                      <span className="text-[4px] text-white/30 font-medium block mb-0.5">
                        Crypto Activity
                      </span>
                      <div className="flex gap-px mb-1">
                        {["Campaigns", "Feed", "Saved"].map((tab, ti) => (
                          <span
                            key={tab}
                            className={`text-[3px] px-1 py-px rounded flex-1 text-center ${
                              ti === 0
                                ? "bg-white/10 text-white/60"
                                : "text-white/25"
                            }`}
                          >
                            {tab}
                          </span>
                        ))}
                      </div>
                      <div className="bg-[#2c2c2e] rounded p-1">
                        <div className="flex items-center gap-1 mb-0.5">
                          <div className="w-2 h-2 rounded-full bg-white/10" />
                          <div>
                            <span className="text-[3.5px] font-medium text-white/60 block">
                              President Donald J. Trump
                            </span>
                            <span className="text-[3px] text-white/25">
                              &quot;Welcome to the first-ever White House
                              Digital Asset Summit...&quot;
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-8 flex flex-col flex-1">
                <h3 className="font-space-grotesk text-xl font-bold text-black mb-2">
                  AGNT Connect
                </h3>
                <span className="inline-block text-[10px] font-bold uppercase tracking-[0.15em] text-black/40 mb-3">
                  Browser Extension
                </span>
                <p className="text-black/50 text-sm leading-relaxed mb-6 flex-1">
                  Your hub lives inside your browser. Access agents, analytics,
                  alerts, and controls without switching tabs. Available now for
                  Chrome.
                </p>
                <div>
                  <motion.a
                    href="https://chromewebstore.google.com/detail/agntconnect/lgdfffagihonfnkcffpikpifhegcdkge"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-black text-white px-6 py-2.5 rounded-full font-bold text-sm inline-flex items-center gap-2 no-underline hover:bg-black/85 transition-colors"
                    whileHover={{ scale: 1.04 }}
                    whileTap={{ scale: 0.96 }}
                  >
                    Install AGNT Connect
                    <ArrowRight size={14} />
                  </motion.a>
                </div>
              </div>
            </div>
          </AnimatedSection>

          {/* AGNT Desktop Card */}
          <AnimatedSection delay={0.2}>
            <div className="h-full bg-white border border-black/[0.08] rounded-2xl overflow-hidden group hover:border-black/[0.15] transition-all duration-500 hover:shadow-lg flex flex-col">
              <div className="relative h-[260px] bg-gradient-to-b from-[#1a1a1f] to-[#111115] overflow-hidden flex items-center justify-center">
                <div className="relative w-[92%] h-[235px] rounded-lg bg-[#1c1c1e] overflow-hidden shadow-2xl border border-white/[0.06]">
                  <div className="h-4 bg-[#2c2c2e] flex items-center px-1.5">
                    <div className="flex gap-[3px] mr-1.5">
                      <div className="w-[5px] h-[5px] rounded-full bg-[#ff5f57]" />
                      <div className="w-[5px] h-[5px] rounded-full bg-[#febc2e]" />
                      <div className="w-[5px] h-[5px] rounded-full bg-[#28c840]" />
                    </div>
                    <div className="flex items-center gap-0.5">
                      <img
                        src={agntLogoSrc}
                        alt=""
                        className="h-2 w-auto object-contain opacity-60"
                      />
                      <span className="text-[5px] text-white/30 font-medium">
                        AGNT.Hub
                      </span>
                    </div>
                  </div>
                  <div className="flex h-[calc(100%_-_16px)]">
                    <div className="w-7 bg-[#1c1c1e] border-r border-white/[0.04] py-1.5 flex flex-col gap-1 items-center">
                      {[true, false, false, false, false].map((active, ni) => (
                        <div
                          key={ni}
                          className={`w-4 h-4 rounded flex items-center justify-center ${active ? "bg-white/10" : ""}`}
                        >
                          <div
                            className={`w-1.5 h-1.5 rounded-sm ${active ? "bg-white/60" : "bg-white/12"}`}
                          />
                        </div>
                      ))}
                      <div className="mt-auto w-4 h-4 rounded flex items-center justify-center">
                        <div className="w-2 h-2 rounded-full bg-white/10" />
                      </div>
                    </div>
                    <div className="flex-1 p-1.5 bg-[#111113]">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-[6px] font-semibold text-white/65">
                          Dashboard
                        </span>
                        <div className="flex items-center gap-2">
                          <div className="flex gap-px">
                            {["Overview", "Agents", "Wallet", "Settings"].map(
                              (t, ti) => (
                                <span
                                  key={t}
                                  className={`text-[4px] px-1 py-px rounded ${
                                    ti === 0
                                      ? "bg-white/8 text-white/50"
                                      : "text-white/20"
                                  }`}
                                >
                                  {t}
                                </span>
                              ),
                            )}
                          </div>
                          <div className="flex items-center gap-0.5 px-1 py-px rounded bg-[#2c2c2e]">
                            <div className="w-1 h-1 rounded-full bg-[#30d158]" />
                            <span className="text-[4px] text-white/30">
                              3 active
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-4 gap-0.5 mb-1">
                        {DASHBOARD_STATS.map((s) => (
                          <div
                            key={s.label}
                            className="bg-[#2c2c2e] rounded p-1"
                          >
                            <span className="text-[4px] text-white/30 block">
                              {s.label}
                            </span>
                            <span className="text-[7px] font-semibold text-white/80 block">
                              {s.val}
                            </span>
                            <span
                              className={`text-[4px] font-medium ${s.subColor}`}
                            >
                              {s.sub}
                            </span>
                          </div>
                        ))}
                      </div>
                      <div className="flex gap-0.5 mb-1">
                        <div className="flex-[2] bg-[#2c2c2e] rounded p-1">
                          <div className="flex items-center justify-between mb-0.5">
                            <span className="text-[4px] text-white/35 font-medium">
                              Portfolio Performance
                            </span>
                            <div className="flex gap-px">
                              {["1D", "7D", "1M", "All"].map((p, pi) => (
                                <span
                                  key={p}
                                  className={`text-[3px] px-0.5 py-px rounded ${
                                    pi === 1
                                      ? "bg-white/8 text-white/50"
                                      : "text-white/20"
                                  }`}
                                >
                                  {p}
                                </span>
                              ))}
                            </div>
                          </div>
                          <div className="h-[24px] flex items-end gap-px">
                            {CHART_BARS.map((h, i) => (
                              <div
                                key={i}
                                className="flex-1 rounded-t-[1px] bg-white/15"
                                style={{ height: `${h}%` }}
                              />
                            ))}
                          </div>
                        </div>
                        <div className="flex-1 bg-[#2c2c2e] rounded p-1">
                          <span className="text-[4px] text-white/35 font-medium block mb-0.5">
                            Allocation
                          </span>
                          <div className="flex flex-col gap-[2px]">
                            {ALLOCATIONS.map((a) => (
                              <div
                                key={a.name}
                                className="flex items-center gap-0.5"
                              >
                                <span className="text-[3px] text-white/30 w-4">
                                  {a.name}
                                </span>
                                <div className="flex-1 h-[3px] bg-white/5 rounded-full overflow-hidden">
                                  <div
                                    className={`h-full rounded-full ${a.color} ${a.w}`}
                                  />
                                </div>
                                <span className="text-[3px] text-white/25 w-3 text-right">
                                  {a.pct}
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="flex gap-0.5 mb-1">
                        <div className="flex-1 flex flex-col gap-0.5">
                          <span className="text-[4px] text-white/25 font-medium">
                            Active Agents
                          </span>
                          {ACTIVE_AGENTS.map((a) => (
                            <div
                              key={a.name}
                              className="bg-[#2c2c2e] rounded px-1 py-[2px] flex items-center gap-1"
                            >
                              <div
                                className={`w-1 h-1 rounded-full ${a.dot} shrink-0`}
                              />
                              <span className="text-[4px] font-medium text-white/55">
                                {a.name}
                              </span>
                              <span className="text-[3px] text-white/25 ml-auto">
                                {a.val}
                              </span>
                            </div>
                          ))}
                        </div>
                        <div className="flex-1 flex flex-col gap-0.5">
                          <span className="text-[4px] text-white/25 font-medium">
                            Recent Transactions
                          </span>
                          {RECENT_TXS.map((tx) => (
                            <div
                              key={tx.action}
                              className="bg-[#2c2c2e] rounded px-1 py-[2px] flex items-center gap-1"
                            >
                              <div
                                className={`w-1 h-1 rounded-full ${tx.color} shrink-0`}
                              />
                              <span className="text-[4px] font-medium text-white/55">
                                {tx.action}
                              </span>
                              <span className="text-[3px] text-white/25 flex-1 truncate">
                                {tx.detail}
                              </span>
                              <span className="text-[3px] text-white/20">
                                {tx.time}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-8 flex flex-col flex-1">
                <h3 className="font-space-grotesk text-xl font-bold text-black mb-2">
                  AGNT Desktop
                </h3>
                <span className="inline-block text-[10px] font-bold uppercase tracking-[0.15em] text-black/40 mb-3">
                  Windows & Mac
                </span>
                <p className="text-black/50 text-sm leading-relaxed mb-6 flex-1">
                  Native app for Windows and Mac. Full hub experience with
                  system notifications and background agent execution.
                </p>
                <div>
                  <span className="inline-block px-5 py-2 rounded-full text-sm font-bold text-black/40 border border-black/[0.1] bg-black/[0.03]">
                    Coming Soon
                  </span>
                </div>
              </div>
            </div>
          </AnimatedSection>

          {/* AGNT Mobile Card */}
          <AnimatedSection delay={0.3}>
            <div className="h-full bg-white border border-black/[0.08] rounded-2xl overflow-hidden group hover:border-black/[0.15] transition-all duration-500 hover:shadow-lg flex flex-col">
              <div className="relative h-[260px] bg-gradient-to-b from-[#1a1a1f] to-[#111115] overflow-hidden flex items-center justify-center">
                <div className="relative w-[110px] h-[230px] rounded-[18px] bg-[#000] overflow-hidden shadow-2xl border border-white/[0.08]">
                  <div className="absolute top-[2px] left-1/2 -translate-x-1/2 w-[42px] h-[11px] rounded-full bg-black z-20" />
                  <div className="absolute top-[2px] left-1/2 -translate-x-1/2 w-[42px] h-[11px] rounded-full bg-[#1c1c1e] z-10" />
                  <div className="pt-4 px-[5px] pb-[4px] h-full flex flex-col bg-[#000]">
                    <div className="flex items-center justify-between mb-1 px-0.5">
                      <span className="text-[5px] font-semibold text-white/70">
                        9:41
                      </span>
                      <div className="flex items-center gap-0.5">
                        <div className="flex gap-[1px]">
                          {[1, 2, 3, 4].map((b) => (
                            <div
                              key={b}
                              className={`w-[2px] rounded-[0.5px] ${b <= 3 ? "bg-white/50" : "bg-white/15"}`}
                              style={{ height: `${b * 1.5 + 2}px` }}
                            />
                          ))}
                        </div>
                        <div className="w-3 h-1.5 rounded-[1px] border border-white/30 flex items-center px-[1px]">
                          <div className="h-[3px] w-[6px] rounded-[0.5px] bg-[#30d158]" />
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center justify-between px-0.5 mb-1.5">
                      <div className="flex items-center gap-0.5">
                        <img
                          src={agntLogoSrc}
                          alt=""
                          className="h-2 w-auto object-contain opacity-70"
                        />
                        <span className="text-[5px] font-semibold text-white/45">
                          Hub
                        </span>
                      </div>
                      <div className="w-3 h-3 rounded-full bg-[#2c2c2e] flex items-center justify-center">
                        <div className="w-1.5 h-1.5 rounded-full bg-violet-400/40" />
                      </div>
                    </div>
                    <div className="bg-[#1c1c1e] rounded-xl p-2 mb-1.5">
                      <span className="text-[4px] text-white/30 block">
                        Total Balance
                      </span>
                      <span className="text-[10px] font-semibold text-white/90 tracking-tight block">
                        $24,892
                      </span>
                      <div className="flex items-center gap-0.5">
                        <span className="text-[4px] text-[#30d158] font-medium">
                          +$342.18
                        </span>
                        <span className="text-[3px] text-white/20">today</span>
                      </div>
                    </div>
                    <div className="flex gap-1.5 justify-center mb-1.5">
                      {MOBILE_ACTIONS.map((btn) => (
                        <div
                          key={btn.label}
                          className="flex flex-col items-center gap-[2px]"
                        >
                          <div className="w-5 h-5 rounded-full bg-[#2c2c2e] flex items-center justify-center">
                            <span className="text-[6px] text-white/55">
                              {btn.sym}
                            </span>
                          </div>
                          <span className="text-[4px] text-white/30">
                            {btn.label}
                          </span>
                        </div>
                      ))}
                    </div>
                    <div className="bg-[#1c1c1e] rounded-lg p-1 mb-1">
                      <div className="flex items-center justify-between mb-0.5 px-0.5">
                        <span className="text-[4px] text-white/30 font-medium">
                          Holdings
                        </span>
                        <span className="text-[3px] text-white/20">
                          See all
                        </span>
                      </div>
                      {MOBILE_HOLDINGS.map((tk) => (
                        <div
                          key={tk.name}
                          className="flex items-center px-0.5 py-[2px] gap-1"
                        >
                          <div className="w-2 h-2 rounded-full bg-white/8" />
                          <span className="text-[4px] font-medium text-white/55 flex-1">
                            {tk.name}
                          </span>
                          <span className="text-[4px] font-medium text-white/65">
                            {tk.val}
                          </span>
                          <span
                            className={`text-[3px] font-medium ${
                              tk.change.startsWith("+")
                                ? "text-[#30d158]/70"
                                : "text-[#ff453a]/70"
                            }`}
                          >
                            {tk.change}
                          </span>
                        </div>
                      ))}
                    </div>
                    <div className="flex flex-col gap-[2px] flex-1">
                      <span className="text-[4px] text-white/25 font-medium px-0.5">
                        Active Agents
                      </span>
                      {MOBILE_AGENTS.map((ag) => (
                        <div
                          key={ag.name}
                          className="flex items-center gap-1 bg-[#1c1c1e] rounded-md px-1.5 py-[2px]"
                        >
                          <div
                            className={`w-1 h-1 rounded-full ${ag.dot} shrink-0`}
                          />
                          <span className="text-[4px] font-medium text-white/55 flex-1 truncate">
                            {ag.name}
                          </span>
                          <span className="text-[3px] text-white/20 shrink-0">
                            {ag.val}
                          </span>
                        </div>
                      ))}
                    </div>
                    <div className="flex pt-0.5 border-t border-white/[0.04]">
                      {["\u25FB", "\u25C8", "\u25B3", "\u25CB"].map(
                        (icon, ti) => (
                          <div
                            key={ti}
                            className="flex-1 flex flex-col items-center py-[2px]"
                          >
                            <span
                              className={`text-[5px] ${ti === 0 ? "text-white/60" : "text-white/20"}`}
                            >
                              {icon}
                            </span>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-8 flex flex-col flex-1">
                <h3 className="font-space-grotesk text-xl font-bold text-black mb-2">
                  AGNT Mobile
                </h3>
                <span className="inline-block text-[10px] font-bold uppercase tracking-[0.15em] text-black/40 mb-3">
                  iOS & Android
                </span>
                <p className="text-black/50 text-sm leading-relaxed mb-6 flex-1">
                  Your agents in your pocket. Monitor performance, control
                  settings, receive push alerts on the go.
                </p>
                <div>
                  <span className="inline-block px-5 py-2 rounded-full text-sm font-bold text-black/40 border border-black/[0.1] bg-black/[0.03]">
                    Coming Soon
                  </span>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}

/* ── Static data extracted outside component body ── */

const TWEETS = [
  {
    user: "Esther Howard",
    handle: "@estherh",
    time: "2h",
    text: "Just worked with a Web3 dev team that actually delivers.\nClean code. Gas optimized. On-chain in a week.\nIf you're building in crypto, don't settle for mid devs.",
    hashtags: "#CryptoDev #Web3Builders",
    likes: "8.2K",
    rts: "1.4K",
  },
  {
    user: "Mr. Crypto Whale",
    handle: "@MCryptoWhale",
    time: "4h",
    text: "Anyone up for 10,000 $XRP?\n\nSimple rules:\nLike & retweet this post\nOnly followers will qualify",
    hashtags: "",
    likes: "24K",
    rts: "8.1K",
  },
];

const TOP_ASSETS = [
  {
    name: "Bitcoin",
    price: "$84,815.18",
    icon: "\u20BF",
    color: "text-[#f7931a]",
  },
  {
    name: "Ethereum",
    price: "$1,631.51",
    icon: "\u039E",
    color: "text-[#627eea]",
  },
  { name: "Solana", price: "129.10", icon: "\u25CE", color: "text-[#9945ff]" },
];

const DASHBOARD_STATS = [
  {
    label: "Total Balance",
    val: "$24,892",
    sub: "+12.4%",
    subColor: "text-[#30d158]",
  },
  {
    label: "24h PnL",
    val: "+$342",
    sub: "across 4 chains",
    subColor: "text-white/20",
  },
  {
    label: "Yield Earned",
    val: "$1,247",
    sub: "this month",
    subColor: "text-white/20",
  },
  {
    label: "Gas Saved",
    val: "$89.40",
    sub: "by agents",
    subColor: "text-white/20",
  },
];

const CHART_BARS = [
  35, 42, 38, 55, 48, 62, 58, 70, 65, 72, 68, 78, 74, 82, 80, 85, 88, 84, 90,
  92, 88, 94, 90, 96,
];

const ALLOCATIONS = [
  { name: "BNB", pct: "32%", w: "w-[32%]", color: "bg-yellow-400/40" },
  { name: "ETH", pct: "28%", w: "w-[28%]", color: "bg-blue-400/40" },
  { name: "ATTS", pct: "22%", w: "w-[22%]", color: "bg-violet-400/40" },
  { name: "SOL", pct: "18%", w: "w-[18%]", color: "bg-emerald-400/40" },
];

const ACTIVE_AGENTS = [
  { name: "Yield Optimizer", val: "14.2% APY", dot: "bg-[#30d158]" },
  { name: "Arb Bot", val: "+$18.40 today", dot: "bg-[#0a84ff]" },
  { name: "Reply Guy", val: "12 replies", dot: "bg-violet-400" },
];

const RECENT_TXS = [
  {
    action: "Swap",
    detail: "ETH \u2192 USDC",
    time: "2m",
    color: "bg-[#0a84ff]",
  },
  {
    action: "Yield",
    detail: "Aave deposit",
    time: "18m",
    color: "bg-[#30d158]",
  },
  {
    action: "Bridge",
    detail: "BSC \u2192 ETH",
    time: "1h",
    color: "bg-[#ff9f0a]",
  },
];

const MOBILE_ACTIONS = [
  { label: "Send", sym: "\u2191" },
  { label: "Receive", sym: "\u2193" },
  { label: "Swap", sym: "\u21C4" },
  { label: "Buy", sym: "+" },
];

const MOBILE_HOLDINGS = [
  { name: "BNB", val: "$4,102", change: "+3.1%" },
  { name: "ETH", val: "$3,480", change: "+1.8%" },
  { name: "ATTS", val: "$2,741", change: "+12%" },
];

const MOBILE_AGENTS = [
  { name: "Yield Optimizer", val: "14.2% APY", dot: "bg-[#30d158]" },
  { name: "Reply Guy", val: "12 replies", dot: "bg-[#0a84ff]" },
  { name: "Smart Alerts", val: "3 triggers", dot: "bg-[#ff9f0a]" },
  { name: "Arb Bot", val: "+$18 today", dot: "bg-violet-400" },
];
